var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "office-building",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.922,
    height: 20,
    viewBox: "0 0 19.922 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_255",
    "data-name": "Path 255",
    d: "M2.172,163.335v-.75a.586.586,0,0,0-1.172,0v12.5a.586.586,0,0,0,.586.586h.9v-2.539a.586.586,0,0,1,1.172,0v2.539H5.141V162.346Zm1.484,7.454a.586.586,0,0,1-1.172,0v-1.172a.586.586,0,0,1,1.172,0Zm0-3.516a.586.586,0,1,1-1.172,0V166.1a.586.586,0,0,1,1.172,0Z",
    transform: "translate(-1 -155.672)",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_256",
    "data-name": "Path 256",
    d: "M410.477,162a.586.586,0,0,0-.586.586v.75L407,162.372v13.3h1.445v-2.539a.586.586,0,0,1,1.172,0v2.539h.859a.586.586,0,0,0,.586-.586v-12.5A.586.586,0,0,0,410.477,162Zm-.859,8.789a.586.586,0,0,1-1.172,0v-1.172a.586.586,0,0,1,1.172,0Zm0-3.516a.586.586,0,1,1-1.172,0V166.1a.586.586,0,0,1,1.172,0Z",
    transform: "translate(-391.141 -155.672)",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_257",
    "data-name": "Path 257",
    d: "M168.422,1.25V.586A.586.586,0,0,0,167.836,0h-6.25A.586.586,0,0,0,161,.586V1.25Z",
    transform: "translate(-154.75)",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_258",
    "data-name": "Path 258",
    d: "M221,442h2.734v2.734H221Z",
    transform: "translate(-212.406 -424.734)",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_259",
    "data-name": "Path 259",
    d: "M145.789,62h-8.2a.586.586,0,0,0-.586.586V79.578h2.109v-3.32a.586.586,0,0,1,.586-.586H143.6a.586.586,0,0,1,.586.586v3.32h2.188V62.586A.586.586,0,0,0,145.789,62Zm-5.9,11.133a.586.586,0,0,1-1.172,0V71.961a.586.586,0,0,1,1.172,0Zm0-3.516a.586.586,0,0,1-1.172,0V68.445a.586.586,0,0,1,1.172,0Zm0-3.516a.586.586,0,0,1-1.172,0V64.93a.586.586,0,0,1,1.172,0Zm2.344,7.031a.586.586,0,0,1-1.172,0V71.961a.586.586,0,0,1,1.172,0Zm0-3.516a.586.586,0,0,1-1.172,0V68.445a.586.586,0,0,1,1.172,0Zm0-3.516a.586.586,0,0,1-1.172,0V64.93a.586.586,0,0,1,1.172,0Zm2.344,7.031a.586.586,0,0,1-1.172,0V71.961a.586.586,0,0,1,1.172,0Zm0-3.516a.586.586,0,0,1-1.172,0V68.445a.586.586,0,0,1,1.172,0Zm0-3.516a.586.586,0,0,1-1.172,0V64.93a.586.586,0,0,1,1.172,0Z",
    transform: "translate(-131.688 -59.578)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/Building.f2d114623b391ffab3b45f0decf413be.svg";
export { ForwardRef as ReactComponent };